export type Cell = [number, number];

export type Handlers = { onStart(c: Cell): void; onMove(c: Cell): void; onEnd(): void };

/** 한 포인터만. cellAt 이 null 이면 그 이벤트는 무시. */
export function attachInput(el: HTMLElement, cellAt: (x: number, y: number) => Cell | null, h: Handlers): () => void {
  let active: number | null = null;
  const pos = (e: PointerEvent): Cell | null => { const r = el.getBoundingClientRect(); return cellAt(e.clientX - r.left, e.clientY - r.top); };
  const down = (e: PointerEvent) => {
    if (active !== null || (e.pointerType === 'mouse' && e.button !== 0)) return;
    const c = pos(e); if (!c) return;
    active = e.pointerId; el.setPointerCapture?.(e.pointerId); e.preventDefault();
    h.onStart(c);
  };
  const move = (e: PointerEvent) => {
    if (e.pointerId !== active) return;
    e.preventDefault();
    const evs = typeof e.getCoalescedEvents === 'function' ? e.getCoalescedEvents() : [];
    for (const ev of evs.length ? evs : [e]) { const c = pos(ev); if (c) h.onMove(c); }
  };
  const up = (e: PointerEvent) => { if (e.pointerId !== active) return; active = null; e.preventDefault(); h.onEnd(); };
  const blur = () => { if (active !== null) { active = null; h.onEnd(); } };
  el.addEventListener('pointerdown', down); el.addEventListener('pointermove', move);
  el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up);
  window.addEventListener('blur', blur);
  const stop = (e: Event) => e.preventDefault();
  el.addEventListener('contextmenu', stop); document.addEventListener('gesturestart', stop);
  return () => {
    el.removeEventListener('pointerdown', down); el.removeEventListener('pointermove', move);
    el.removeEventListener('pointerup', up); el.removeEventListener('pointercancel', up);
    window.removeEventListener('blur', blur); el.removeEventListener('contextmenu', stop); document.removeEventListener('gesturestart', stop);
  };
}
